import * as React from 'react';
import { st, classes } from './LikeButton.st.css';
import { LikeHeart, LikeHeartFill } from '@wix/wix-ui-icons-common/on-stage';
import { IconToggle, IconToggleLabelPlacement } from '../IconToggle';
export class LikeButton extends React.Component {
    render() {
        const { label, labelPlacement, onChange, checked, disabled, className } = this.props;
        return (React.createElement("div", { className: classes.likeButton },
            React.createElement(IconToggle, { className: st(classes.root, { checked, disabled }, className), icon: React.createElement(LikeHeart, null), checkedIcon: React.createElement(LikeHeartFill, null), label: label, disabled: disabled, onChange: onChange, checked: checked, labelPlacement: labelPlacement, animation: true, "data-hook": this.props['data-hook'] })));
    }
}
LikeButton.displayName = 'LikeButton';
LikeButton.defaultProps = {
    label: '',
    labelPlacement: IconToggleLabelPlacement.END,
    checked: false,
    disabled: false,
};
//# sourceMappingURL=LikeButton.js.map